export default {
  updateLanguage: (_, data, { cache }) => {
    const { language } = data;
    cache.writeData({ data: { language } });
    return null;
  },
};
